export enum BankType {
  AUTOMATIC = 'automatic',
  MANUAL = 'manual',
}
